import React, { useState, useEffect } from 'react';
import { FilterMatchMode } from 'primereact/api';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import ClassTimeTableCard from './ClassTimeTableCard';
import { TabView, TabPanel } from 'primereact/tabview';
import TeacherTimeTableCard from './TeacherTimeTableCard';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const TimeTableConfiguration = () => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [teachersList, setTeachersList] = useState([]);
    const [classConfigurationData, setClassConfigurationData] = useState([]);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassConfigurationDetail(loginData?._id);
        GetClassList(loginData?._id);
        GetTeachersList(loginData?._id);
    }, []);


    const GetClassList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        ...x,
                        Class: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTeachersList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getTeacherDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTeachersList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const GetClassConfigurationDetail = async (id) => {
        try {
            let data = {
                UserId: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getClassConfigurationList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let resData = res.data;
                    setClassConfigurationData(resData);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-clock"></i>
                    <h2>Time Table</h2>
                </div>
            </div>
            <div className='e-tab-main'>
                <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                    <TabPanel header="Class">
                        <div>
                            {
                                classList.map(x => (
                                    <ClassTimeTableCard key={x?._id} ClassId={x?._id} ClassName={x?.Class} ClassConfigurationData={classConfigurationData} />
                                ))
                            }
                        </div>
                    </TabPanel>
                    <TabPanel header="Teacher">
                        <div>
                            {
                                teachersList.map(x => (
                                    <TeacherTimeTableCard key={x?._id} TeacherId={x?._id} TeacherName={x?.Name} ClassList={classList} />
                                ))
                            }
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default TimeTableConfiguration;
